import { render, staticRenderFns } from "./subsidyRules.vue?vue&type=template&id=d9bf6604&scoped=true"
import script from "./subsidyRules.vue?vue&type=script&lang=js"
export * from "./subsidyRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bf6604",
  null
  
)

export default component.exports